<template>
  <div class="container LegalFileDetail">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('settlementUnit.ConfidentialityAgreementApply')" name="1">
        <div class="searchBox_top">
          <el-button v-if="LegalFileDetailForm.status=='draft' || LegalFileDetailForm.status=='appr_rej'" type="primary" @click="save" v-acl="SaveLawFile">{{$t('common.saveDraft')}}
          </el-button>
          <!--保存-->
          <el-button v-if="LegalFileDetailForm.status=='draft' || LegalFileDetailForm.status=='appr_rej'" type="primary" @click="submit" v-acl="SubmitLawFile">{{$t('common.submit')}}
          </el-button>
          <!--提交-->
          <el-button v-if="LegalFileDetailForm.canAudit" key="CompleteLawFile" type="primary" @click="goComplete" v-acl="CompleteLawFile">审批</el-button>
          <template>
            <el-upload style="float:left;padding-right: 10px;" ref="upload" action="upload" :http-request="uploadConfirmSign" :show-file-list="false" v-if="LegalFileDetailForm.status=='appr_pass' && checked" name="file">
              <el-button v-if="LegalFileDetailForm.status=='appr_pass'" slot="trigger" type="primary">
                {{$t('settlementUnit.appr_pass')}}
              </el-button>
            </el-upload>
            <el-button v-if="LegalFileDetailForm.status=='appr_pass' && !checked" slot="trigger" type="primary" @click="beforeUpload">
              {{$t('settlementUnit.appr_pass')}}
            </el-button>
          </template>
          <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        </div>
        <el-form :model="LegalFileDetailForm" ref="LegalFileDetailForm" :rules="rules" label-width="180px">
          <!-- :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'" -->
          <el-card class="box-card">
            <!--基础信息-->
            <div slot="header" class="clearfix">
              <span>{{$t('settlementUnit.baseInfo')}}</span>
            </div>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.formType')" prop="formType">
                  <!--表单类型
                                    当表单类型为保密协议0/业务关系协议BRA 3 时，我方用印主体名称默认为：金拱门(中国)有限公司-置灰不可编辑，
                                    当表单类型为玩具1/非玩具类2时，我方用印主体名称默认为乐信(上海)贸易有限公司-置灰不可编辑；-->
                  <el-select v-model="LegalFileDetailForm.formType" :disabled="formTypeDisabled ||(LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole')" @change="formTypeChange">
                    <el-option :key="index" v-for="(item,index) in formTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.applyDate')" prop="applyDate">
                  <!--申请日期-->
                  <el-date-picker value-format="yyyy-MM-dd" v-model="LegalFileDetailForm.applyDate" type="date" disabled :placeholder="$t('common.selDate')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <el-form-item :label="$t('settlementUnit.title')" prop="theTitle">
                  <!--标题-->
                  <el-input v-model="LegalFileDetailForm.theTitle" clearable :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.agent')" prop="agent">
                  <!--经办人-->
                  <el-input v-model.trim="LegalFileDetailForm.agent" disabled :placeholder="$t('material.DisplayAfterSave')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.agentDepartment')" prop="agentDepartment">
                  <!--经办人所属部门-->
                  <el-input v-model.trim="LegalFileDetailForm.agentDepartment" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.Protocoltype')" prop="protocolType">
                  <!--协议类型-->
                  <ic-select clearable table="TM_LAW_FILE" field="PROTOCOL_TYPE" v-model="LegalFileDetailForm.protocolType" :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.isMCDTemplate')" prop="useMdTemplate">
                  <!--是否使用麦当劳标准模板 默认是-->
                  <ic-select v-if="LegalFileDetailForm.formType==3" clearable table="TM_LAW_FILE" field="Y_N" v-model="LegalFileDetailForm.useMdTemplate" disabled></ic-select>
                  <ic-select v-else clearable table="TM_LAW_FILE" field="Y_N" v-model="LegalFileDetailForm.useMdTemplate" :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.ContractName')" prop="contractName">
                  <!--合同名称-->
                  <el-input v-model="LegalFileDetailForm.contractName" :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.ContractNo')" prop="contractNo">
                  <!--合同编号-->
                  <el-input v-model.trim="LegalFileDetailForm.contractNo" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <!--合同签约方-->
            <div slot="header" class="clearfix">
              <span>{{$t('settlementUnit.ContractingParties')}}</span>
            </div>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.OurPrincipalName')" prop="subjectName">
                  <!--我方主体名称-->
                  <ic-select table="TM_LAW_FILE" field="SUBJECT_NAME" :disabled="LegalFileDetailForm.formType!='' || (LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole')" v-model="LegalFileDetailForm.subjectName"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.supplierMainName')" prop="supplierName">
                  <!--供应商主体名称-->
                  <el-input v-model="LegalFileDetailForm.supplierName" clearable :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-card>
          <el-card class="box-card">
            <!--合同概述-->
            <div slot="header" class="clearfix">
              <span>{{$t('settlementUnit.ContractOverview')}}</span>
            </div>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.contractValidity')" prop="termOfContract">
                  <!--合同有效期-->
                  <ic-select clearable table="TM_LAW_FILE" field="TERM_OF_CONTRACT" v-model="LegalFileDetailForm.termOfContract" :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.isAutoRenewal')" prop="isAutomaticRenewal">
                  <!--是否包含自动续期条款 默认否，不可编辑-->
                  <ic-select clearable table="TM_LAW_FILE" field="Y_N" v-model="LegalFileDetailForm.isAutomaticRenewal" disabled></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.AutoRenewalCondition')" prop="automaticRenewalConditions">
                  <!--简述自动续期条件-->
                  <ic-select clearable table="TM_LAW_FILE" field="AUTOMATIC_RENEWAL_CONDITIONS" v-model="LegalFileDetailForm.automaticRenewalConditions" :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'">
                  </ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item :label="$t('settlementUnit.amountAndType')" prop="amountType">
                  <!--合同涉及金额类型-->
                  <ic-select clearable table="TM_LAW_FILE" field="AMOUNT_TYPE" v-model="LegalFileDetailForm.amountType" disabled></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <!--合同范本-->
            <div slot="header" class="clearfix">
              <span>{{$t('settlementUnit.downloadTemplate')}}</span>
              <el-link v-if="LegalFileDetailForm.formType==0" style='margin-left:20px' type="primary" @click.native="downloadTemplate('/templates/download/附件二 麦当劳保密协议_CN.PDF','附件二 麦当劳保密协议_CN.PDF')">附件二 麦当劳保密协议_CN.PDF</el-link>
              <el-link v-if="LegalFileDetailForm.formType==1" style='margin-left:20px' type="primary" @click.native="downloadTemplate('/templates/download/采购协议延伸库存.pdf','采购协议延伸库存.pdf')">采购协议延伸库存.pdf</el-link>
              <el-link v-if="LegalFileDetailForm.formType==2" style='margin-left:20px' type="primary" @click.native="downloadTemplate('/templates/download/采购协议非延伸库存.pdf','采购协议非延伸库存.pdf')">采购协议非延伸库存.pdf</el-link>
            </div>
            <el-row v-show='LegalFileDetailForm.useMdTemplate==1'>
              <!--合同版本 》 供应商合同提案-->
              <el-col :span="3">{{$t('settlementUnit.ContractVersion')}}</el-col>
              <!-- <el-col :span="3"><span style="color:red">*</span>{{$t('settlementUnit.ContractVersion')}}</el-col> -->
              <el-col :span="20">
                <el-form-item label-width="0" prop="tmLawFileId" style="margin-bottom: 0px;" v-if="!(LegalFileDetailForm.formType==0 && LegalFileDetailForm.useMdTemplate==0)">
                  <el-upload style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple :disabled="LegalFileDetailForm.status=='appr_ss' || LegalFileDetailForm.status=='appr_lp' || LegalFileDetailForm.status=='appr_pass' || LegalFileDetailForm.status=='pigeonhole'" name="file">
                    <el-button slot="trigger" size="small" type="primary">
                      {{$t('common.selectFile')}}
                    </el-button>
                    <!--选取文件-->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <div>
              <span :key="index" v-for="(item,index) in fileList" style="padding-right: 15px;">
                <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
                <el-button type="primary" size="mini" style="margin-left: 20px;" @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList)">
                  {{$t('common.del')}}
                </el-button>
                <!--删除-->
              </span>
            </div>
            <div style="border-bottom: 1px solid #EBEEF5;padding: 10px;"></div>
            <div>
              <div style="margin: 15px 0;">{{$t('settlementUnit.fileListWater')}}</div>
              <!--水印版本-》已批准合同-->
              <span :key="index" v-for="(item,index) in fileListWater" style="padding-right: 15px;">
                <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
                <el-button type="primary" size="mini" style="margin-left: 20px;" @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList)">
                  {{$t('common.del')}}
                </el-button>
                <!--删除-->
              </span>
            </div>
            <div style="border-bottom: 1px solid #EBEEF5;padding: 10px;"></div>
            <el-row style="margin: 15px 0;">
              <el-col :span="3">{{$t('settlementUnit.appr_pass')}}</el-col>
            </el-row>
            <el-row style="margin: 15px 0;" v-if="LegalFileDetailForm.status=='appr_pass'">
              <el-checkbox v-model="checked">
                供应商兹确认，本上传合同已经双方充分协商和沟通，供应商已充分理解并知悉合同的全部内容，且上传的签署版本与供应商下载的水印版内容完全一致。
              </el-checkbox>
            </el-row>

            <div>
              <span style="padding-right: 35px;"></span>
              <span :key="index" v-for="(item,index) in fileListSign" style="padding-right: 15px;">
                <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
                <!--<el-button type="primary" size="mini" style="margin-left: 20px;"
                                           @click.native.prevent="deleteFile(item.tmDocumentId,index,fileListSign)">
                                    {{$t('common.del')}}
                                </el-button>-->
              </span>
            </div>
          </el-card>
          <!-- <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{$t('settlementUnit.SealRelated')}}</span>
                        </div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item :label="$t('settlementUnit.isSeal')" prop="needOurSeal">
                                    <ic-select clearable table="TM_LAW_FILE" field="Y_N"
                                               v-model="LegalFileDetailForm.needOurSeal"></ic-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item :label="$t('settlementUnit.SealName')" prop="sealName">
                                    <ic-select table="TM_LAW_FILE" field="SUBJECT_NAME"
                                               v-model="LegalFileDetailForm.subjectName" disabled></ic-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item :label="$t('settlementUnit.SealKeeper')" prop="sealKeeper">
                                    <el-input v-model.trim="LegalFileDetailForm.sealKeeper" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>-->
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="4">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion') "></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="showApproval" width="500px">
      <el-form class="form_border" label-width="120px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.auditor')">
              <el-input v-model="username" class="handle-input" disabled />
            </el-form-item>

            <el-form-item :label="$t('common.approvalTime') ">
              <el-input v-model="date" class="handle-input" disabled />
            </el-form-item>
            <el-form-item :label="$t('common.approvalResults') " prop="status">
              <el-radio v-model="status" label="1">{{$t('common.pass')}}</el-radio>
              <el-radio v-model="status" label="2">{{$t('common.noPass')}}</el-radio>
            </el-form-item>

            <el-form-item :label="$t('common.approvalRemarks') " prop="remark">
              <el-input type="textarea" v-model="remark" class="handle-input" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="complete">{{$t('common.confirm')}}</el-button>
        <el-button type="primary" @click="showApproval = false">{{$t('common.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "../../../api/common/file-utils";
import { apiService } from "../../../api/settlementUnit/lega-file";
import { Message } from "element-ui";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFun from "@/utils/commonFun";
import commonConstants from "@/constants/commonConstants";
export default {
  components: { IcSelect },
  data: () => {
    return {
      TemplateList: [
        { path: '/templates/download/Global Business Case template.DOC', name: 'Global Business Case template.DOC' },
      ],
      formTypeDisabled: false,
      fileList: [],
      fileListSign: [],
      currentTab: '1',
      disSubjectName: true,
      LegalFileDetailForm: {
        theTitle: null,
        agent: null,
        agentDepartment: null,
        agentId: null,
        formType: '',
        applyDate: null,
        protocolType: '0',
        useMdTemplate: '0',
        contractName: null,
        contractNo: null,
        subjectName: '4',
        supplierName: null,
        termOfContract: '0',
        isAutomaticRenewal: '0',
        automaticRenewalConditions: "1",
        amountType: 2,
        tmLawFileId: null,
        needOurSeal: '0',
        sealName: null,
        sealKeeper: null,
        canAudit: false,
        tmSupplierId: '',
        status: 'draft',
      },
      attachment: { documents: null, seq: '1', tsRecId: null, tsReckindId: 'TM_LAW_FILE' },
      showApproval: null,
      username: null,
      data: null,
      status: '1',
      remark: null,
      auditLog: [],//审批日志
      formTypeList: [],//表单类型
      fileListWater: [],//审批日志
      totalCount: 0,
      rules: {
        theTitle: [{ required: true, message: "不能为空", trigger: 'blur' }],
        formType: [{ required: true, message: "不能为空", trigger: 'change' }],
        protocolType: [{ required: true, message: "不能为空", trigger: 'change' }],
        useMdTemplate: [{ required: true, message: "不能为空", trigger: 'change' }],
        subjectName: [{ required: true, message: "不能为空", trigger: 'change' }],
        termOfContract: [{ required: true, message: "不能为空", trigger: 'change' }],
        contractName: [{ required: true, message: "不能为空", trigger: 'blur' }],
        automaticRenewalConditions: [{ required: true, message: "不能为空", trigger: 'blur' }],
        supplierName: [{ required: true, message: "不能为空", trigger: 'blur' }],
        needOurSeal: [{ required: true, message: "不能为空", trigger: 'change' }],
      },
      formType: '',
      checked: '',
    }
  },
  // watch: {
  //     'LegalFileDetailForm.formType': function (val) {
  //         let that = this
  //         if(that.formTypeList.length>0){
  //             let data = that.formTypeList.filter(item => item.code === val)
  //             that.LegalFileDetailForm.theTitle = data[0].chineseValue
  //             that.LegalFileDetailForm.contractName = data[0].chineseValue
  //         }

  //     },
  // },
  created() {
    let that = this
    this.getInputChoiceValues();
    this.id = this.$route.query.id;
    if (this.id) {
      this.getFiles();
      this.getFilesSign();
      this.queryLawFileInfo()
      this.getFilesWater()
    } else {
      this.queryPrimaryKey()
    }
    //审核人：获取当前账号对应账号名称
    // 审核日期：系统当前日期
    this.username = localStorage.getItem("ms_username");
    this.date = this.$options.filters["dateFormatFilter"](new Date())
    let supplierObj = JSON.parse(localStorage.getItem("supplierObj"));
    if (this.$route.query.tmSupplierId) {//如果路由中有tmSupplierId 是从供应商跳过来
      Promise.all([that.getInputChoiceValues()]).then(() => {
        this.formType = this.$route.query.formType
        this.formTypeChange(this.$route.query.formType)
        let data = that.formTypeList.filter(item => item.code == that.formType.toString())
        that.$set(that.LegalFileDetailForm, "theTitle", data[0].chineseValue);
        that.$set(that.LegalFileDetailForm, "contractName", data[0].chineseValue);
        this.tmSupplierId = this.$route.query.tmSupplierId
        this.LegalFileDetailForm.tmSupplierId = this.$route.query.tmSupplierId
        this.LegalFileDetailForm.supplierName = this.$route.query.supplierName
        this.LegalFileDetailForm.theTitle = data[0].chineseValue
        this.LegalFileDetailForm.contractName = data[0].chineseValue
        this.formTypeDisabled = true
        this.LegalFileDetailForm.formType = this.$route.query.formType.toString()
        //直接保存
        apiService.save(that.LegalFileDetailForm).then(res => {
          if (res.code === '200') {
            Message({ message: this.$t('common.operateSuccess'), type: "success" });
            this.id = res.data
            // that.queryLawFileInfo()
            this.$router.replace({
              path: `/LegalFileDetail`,
              query: { id: res.data, timestamp: new Date().getTime() }
            });
            this.queryLawFileInfo(res.data)


          } else {
            Message({ message: res.msg, type: "error" });
          }
        });
      })

    } else {
      if (supplierObj) {
        this.LegalFileDetailForm.tmSupplierId = supplierObj.tmSupplierId
        //this.LegalFileDetailForm.supplierName = supplierObj.supplierName
      }
    }


  },
  methods: {
    //获取主键id
    queryPrimaryKey() {
      apiService.queryPrimaryKey().then(res => {
        if (res.code === '200') {
          this.id = res.data;
          this.LegalFileDetailForm.tmLawFileId = res.data
        }
      });
    },
    //查询详情
    queryLawFileInfo() {
      let that = this
      apiService.queryLawFileInfo(this.id).then(res => {
        if (res.data) {
          that.LegalFileDetailForm = res.data;
          that.auditLog = res.data.logs;
        }
      });
    },
    //保存
    save() {
      apiService.save(this.LegalFileDetailForm).then(res => {
        if (res.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          // this.historyBack()
          this.id = res.data
          this.queryLawFileInfo()
        } else {
          Message({ message: res.msg, type: "error" });
        }
      });
    },
    //提交
    submit() {
      if (this.id && this.fileList.length < 1 && this.LegalFileDetailForm.useMdTemplate == 1) {
        Message({ message: '请上传合同版本', type: "error" });
        return false;
      }
      // if (this.id && this.fileList.length < 1 && !(this.LegalFileDetailForm.formType==0 && this.LegalFileDetailForm.useMdTemplate==0)) {
      //     Message({message: '请上传合同版本', type: "error"});
      //     return false;
      // }
      /*if (this.id && this.fileListSign.length < 1) {
          Message({message: '请上传签字附件', type: "error"});
          return false;
      }*/
      this.$refs.LegalFileDetailForm.validate(valid => {
        if (valid) {
          apiService.submit(this.LegalFileDetailForm).then(res => {
            if (res.code === '200') {
              Message({ message: this.$t('common.operateSuccess'), type: "success" });
              this.historyBack()
            } else {
              Message({ message: res.msg, type: "error" });
            }
          });
        } else {
          Message({ message: '请填写必填的数据', type: "error" });
          return false;
        }
      });
    },
    formTypeChange(val) {
      let that = this
      switch (parseInt(val)) {
        case 0: this.LegalFileDetailForm.subjectName = '4'; break;
        case 1: this.LegalFileDetailForm.subjectName = '29'; break;
        case 2: this.LegalFileDetailForm.subjectName = '29'; break;
        case 3: this.LegalFileDetailForm.subjectName = '4', that.LegalFileDetailForm.useMdTemplate = '1'; break;
      }
      if (that.formTypeList.length > 0) {
        let data = that.formTypeList.filter(item => item.code == val)
        that.LegalFileDetailForm.theTitle = data[0].chineseValue
        that.LegalFileDetailForm.contractName = data[0].chineseValue
      }
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'TM_LAW_FILE';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //签字附件——文件列表数据获取
    getFilesSign: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'TM_LAW_FIEL_SIGN';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileListSign = fileRes;
      })
    },
    //水印版本——文件列表数据获取
    getFilesWater: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'TM_LAW_FILE_WATER';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileListWater = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUploadLms(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.id;
        attachment.tsReckindId = 'TM_LAW_FILE';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //签字文件上传
    uploadConfirmSign: function (item) {
      //只能上传一个，再次上传是覆盖，那么上传之前先删除
      if (this.fileListSign.length > 0) {
        this.deleteFile(this.fileListSign[0].tmDocumentId, 0, this.fileListSign)
      }
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUploadLms(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.id;
        attachment.tsReckindId = 'TM_LAW_FIEL_SIGN';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFilesSign();
          //签字附件 上传后调用归档接口
          apiService.pigeonhole(_this.id)
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFileLms(row)
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    goComplete: function () {
      //    系统校验当前状态是否为“待SS CategoryLeader审批“，校验通过，弹出审核对话框。校验不通过系统报错”当前审批节点不正确“
      if (this.LegalFileDetailForm.canAudit) {
        this.showApproval = true
      } else {
        Message({ message: '当前审批节点不正确', type: "warning" });
      }
    },
    //审批
    complete() {
      if (this.status === '2' && !this.remark) {
        Message({ message: '未通过则备注信息必填', type: "warning" });
        return
      }
      apiService.complete({ bizId: this.id, status: this.status, remark: this.remark }).then(res => {
        if (res.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          this.showApproval = false
          this.historyBack()
        } else {
          Message({ message: res.msg, type: "error" });
        }
      });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    getInputChoiceValues() {
      return new Promise((resolve, reject) => {
        let that = this
        let mapObj = {};
        mapObj["TM_LAW_FILE:FORM_TYPE"] = "TM_LAW_FILE:FORM_TYPE";
        inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
          that.formTypeList = res["TM_LAW_FILE:FORM_TYPE"];
          console.log(that.formTypeList)
          resolve()
        });
      })


    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    beforeUpload() {
      Message({ message: '请先勾选协议再上传，谢谢。', type: "warning" });
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
<style>
.el-upload {
  border-radius: 3px !important;
}
.LegalFileDetail
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
}
</style>
